import React, { useEffect, useState } from "react";
import * as classes from "./trialStepCreatingAccount.module.scss";
import FlowStepContainer from "@components/flows/shared/flowStepContainer";
import LinkedInConversionPixel from "@components/flows/shared/linkedInConversionPixel";
import CapterraLeadConversion from "@components/flows/shared/capterraLeadConversion";
import mangomint from "@api/mangomint";
import { getVisitInfo } from "@utils/visitTracking";
import { useReferralData } from "@hooks/referral/useReferralData";

const getDetectedTimezoneId = () => {
  try {
    const dateTimeFormat = new Intl.DateTimeFormat("default");
    return dateTimeFormat.resolvedOptions().timeZone;
  } catch (t) {
    // Do nothing, browser may not support Intl.DateTimeFormat
  }
};

export default function TrialStepCreatingAccount({
  data,
  isDev,
  doApiSignup,
  isMobile,
  onMobileComplete,
  onDataSubmit,
}) {
  const [progressCounter, setProgressCounter] = useState(0);
  const [authUrl, setAuthUrl] = useState();
  const [redirectInProgres, setRedirectInProgress] = useState(false);
  const { referralData, trackReferralTrialSignup } = useReferralData();

  const demoDataSteps = [
    "",
    "Adding staff members...",
    "Adding services...",
    "Adding clients...",
    "Adding products...",
    "Adding appointments...",
    "Finishing setup...",
  ];

  useEffect(() => {
    if (isDev && !doApiSignup) {
      return;
    }

    trackReferralTrialSignup();

    const apiData = {
      firstName: data["first-name"],
      lastName: data["last-name"],
      email: data["email"],
      password: data["password"],
      businessName: data["business-name"],
      website: data["website"],
      businessServiceTypes: data["business-services"],
      businessSize: data["employees"],
      phone: data["phone"],
      detectedTimezoneId: getDetectedTimezoneId(),
      dev: isDev,
      firstVisitInfo: getVisitInfo("first", true),
      currentVisitInfo: JSON.stringify({ ...getVisitInfo("current"), fromDemoFlow: data?.fromDemoFlow }),
      ...(referralData && { referralData: JSON.stringify(referralData) }),
    };

    mangomint
      .signUp(apiData)
      .then((response) => {
        if (window && response.data && response.data.url) {
          setAuthUrl(response.data.url);
        }
      })
      .catch((e) => {
        alert("An unknown error occurred. Please send us a chat message.");
        console.error(e);
      });
  }, []);

  useEffect(() => {
    const timeout = isDev ? 100 : 1500;
    const timer = setInterval(() => {
      setProgressCounter((c) => c + 1);
    }, timeout);
    if (isDev && isMobile) {
      setTimeout(() => {
        onMobileComplete();
        return () => clearInterval(timer);
      }, 2000);
    }
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (isMobile && authUrl != null && !redirectInProgres) {
      onDataSubmit({
        authUrl: authUrl != null ? authUrl : "https://app.mangomint.com",
      });
      onMobileComplete();
      return;
    }
    if (progressCounter >= demoDataSteps.length && authUrl != null && !redirectInProgres) {
      setRedirectInProgress(true);
      window.location.href = authUrl;
    }
  }, [progressCounter, authUrl]);

  const statusUpdateIndex = Math.min(progressCounter, demoDataSteps.length - 1);
  const statusUpdate = demoDataSteps[statusUpdateIndex];

  return (
    <FlowStepContainer overrideStepLabel="Done" noStepLabel={true} title="Creating Your Account">
      <CapterraLeadConversion />

      <div className={classes.desc}>
        <div className={classes.descInner}>
          <p className={classes.subtext}>
            We are adding some sample data to your account, this could take a few seconds.
          </p>
          <div>
            <div className={classes.spinner} />
            <p className={classes.statusUpdate}>{statusUpdate}</p>
          </div>
        </div>
      </div>
      <LinkedInConversionPixel />
    </FlowStepContainer>
  );
}
